import React from 'react';

const SearchFilterItem = ({filterTag, filterLabel, className}) => (
	<li data-filter-tag={filterTag} className={className}>
		{filterLabel}
	</li>
)

export default SearchFilterItem;